"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkContextProvider;

var _react = _interopRequireWildcard(require("react"));

var _LinkContext = _interopRequireDefault(require("./LinkContext"));

var _router = _interopRequireDefault(require("next/router"));

/**
 * Provides a context that allows links to pass data directly to pages via the `pageData` prop.
 */
function LinkContextProvider(_ref) {
  var children = _ref.children;
  var linkPageData = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var onRouteChangeComplete = function onRouteChangeComplete() {
      return linkPageData.current = undefined;
    };

    _router["default"].events.on('routeChangeComplete', onRouteChangeComplete);

    return function () {
      _router["default"].events.off('routeChangeComplete', onRouteChangeComplete);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_LinkContext["default"].Provider, {
    value: linkPageData
  }, children);
}
//# sourceMappingURL=LinkContextProvider.js.map